import { requestData } from '../../../shared/lib/mediaUtils.ts'

export class AppAudioRecorder {
  audioRecorder: MediaRecorder
  audioChunks: Blob[] = []
  private stopping?: Promise<Blob>

  constructor(stream: MediaStream) {
    this.audioRecorder = new MediaRecorder(stream)
    this.audioRecorder.addEventListener('dataavailable', (e) => {
      this.audioChunks.push(e.data)
    })
  }
  start() {
    if (this.audioRecorder.state === 'recording') return
    this.stopping = undefined
    this.audioChunks = []
    try {
      this.audioRecorder.start()
    } catch (error) {
      throw Object.assign(
        new Error('Необходимо разрешить доступ к микрофону'),
        { cause: error },
      )
    }
  }

  requestData() {
    return requestData(this.audioRecorder)
  }

  togglePause() {
    if (this.audioRecorder.state == 'paused') {
      this.audioRecorder.resume()
    } else {
      this.audioRecorder.pause()
    }
  }
  stopRecord() {
    if (this.stopping) return this.stopping
    if (this.audioRecorder.state === 'inactive')
      return Promise.resolve(undefined)
    this.stopping = new Promise<Blob>((resolve, reject) => {
      const mimeType = this.audioRecorder.mimeType
      const cleanup = () => {
        clearTimeout(timeout)
        this.audioRecorder.removeEventListener('stop', stopped)
        this.audioRecorder.removeEventListener('error', failed)
      }
      const stopped = () => {
        cleanup()
        resolve(new Blob(this.audioChunks, { type: mimeType }))
      }
      const failed = (event: Event) => {
        cleanup()
        reject(
          Object.assign(new Error('Audio recording failed'), {
            cause: (event as Event & { error?: DOMException }).error,
          }),
        )
      }
      const timeout = setTimeout(() => {
        cleanup()
        reject(new Error('Audio recording did not finish within 5000 ms'))
      }, 5000)
      this.audioRecorder.addEventListener('stop', stopped, { once: true })
      this.audioRecorder.addEventListener('error', failed, { once: true })
      try {
        this.audioRecorder.stop()
      } catch (error) {
        cleanup()
        reject(error)
      }
    })
    return this.stopping
  }
}
